<nav class="d-flex justify-content-between align-items-center">
    <ul class="pagination">
        <li class="page-item mr-1" [class.disabled]="currentPage === 1">
            <button class="page-link mr-2" (click)="prevPage()" [disabled]="currentPage === 1">
                <i class="bi bi-chevron-left"></i>
            </button>
        </li>
        <li *ngFor="let page of pageNumbers" class="page-item" [class.active]="page === currentPage"
            [class.disabled]="page === '...'">
            <button class="page-link" (click)="goToPage(page)" [disabled]="page === '...'">
                {{ page }}
            </button>
        </li>
        <li class="page-item" [class.disabled]="currentPage === totalPages">
            <button class="page-link ml-2" (click)="nextPage()" [disabled]="currentPage === totalPages">
                <i class="bi bi-chevron-right"></i>
            </button>
        </li>
    </ul>

    <!-- <p class="m-0">Resultaten: {{resultRange}} van {{totalItems}}</p> -->
</nav>